import React from 'react';

/**
 * The Slightor mark: a tapered four-point star (light) with a small companion
 * sparkle. Drawn as vector so it stays crisp from favicon to hero. `tone`
 * picks the fill: gold on dark/cream surfaces, white on gold tiles.
 */
export const BrandMark: React.FC<{ size?: number; tone?: 'gold' | 'white' | 'charcoal'; glow?: boolean; className?: string }> =
  ({ size = 24, tone = 'gold', glow = false, className }) => {
    const fill = tone === 'white' ? '#FFFFFF' : tone === 'charcoal' ? '#1A1A1A' : 'var(--color-primary, #C8A55B)';
    return (
      <svg width={size} height={size} viewBox="0 0 64 64" className={className} aria-hidden focusable="false">
        {glow && (
          <defs>
            <radialGradient id="slightor-glow" cx="50%" cy="50%" r="50%">
              <stop offset="0%" stopColor={fill} stopOpacity="0.55" />
              <stop offset="100%" stopColor={fill} stopOpacity="0" />
            </radialGradient>
          </defs>
        )}
        {glow && <circle cx="30" cy="34" r="22" fill="url(#slightor-glow)" />}
        {/* Main star — long vertical ray, shorter horizontal, concave sides. */}
        <path
          fill={fill}
          d="M30 4 C31.6 22 33.4 30.2 52 34 C33.4 37.8 31.6 46 30 62 C28.4 46 26.6 37.8 8 34 C26.6 30.2 28.4 22 30 4 Z"
        />
        {/* Companion sparkle, upper right. */}
        <path
          fill={fill}
          d="M50 10 C50.5 15 51.2 17.6 57 18.5 C51.2 19.4 50.5 22 50 27 C49.5 22 48.8 19.4 43 18.5 C48.8 17.6 49.5 15 50 10 Z"
        />
      </svg>
    );
  };
